/**
 * Onyx newsletter forms.
 *
 * Progressive enhancement only:
 * - blocks submission when the honeypot field has been filled in (bots);
 * - moves focus to the success or error message after a round trip so screen
 *   reader users are told what happened.
 *
 * The form works without this module.
 */

const HONEYPOT_NAME = 'onyx_company';

/** @param {SubmitEvent} event */
function guardHoneypot(event) {
  const form = event.currentTarget;
  if (!(form instanceof HTMLFormElement)) return;

  const trap = form.elements.namedItem(HONEYPOT_NAME);

  if (trap instanceof HTMLInputElement && trap.value.trim() !== '') {
    event.preventDefault();
    event.stopPropagation();
  }
}

function init() {
  const forms = document.querySelectorAll('.onyx-newsletter__form, .onyx-welcome-popup__form');

  for (const form of forms) {
    if (form.dataset.onyxNewsletterReady === 'true') continue;
    form.dataset.onyxNewsletterReady = 'true';
    form.addEventListener('submit', guardHoneypot);
  }

  const message = document.querySelector('.onyx-newsletter__message');

  if (message instanceof HTMLElement && window.location.hash.startsWith('#onyx-newsletter')) {
    message.focus({ preventScroll: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
